export type LegacyRouteTransition = "pending" | "redirecting" | "render";

const LEGACY_ROUTE_TARGETS: Readonly<Record<string, string>> = {
  "/quizzes": "/atividades",
  "/missoes-old": "/atividades",
  "/missoes/aprovar": "/atividades",
  "/players": "/classes",
  "/details": "/classes",
  "/attitudes": "/classes",
  "/purchases": "/rewards/redesign",
  "/requests": "/rewards/redesign",
  "/rewards": "/rewards/redesign",
  "/gift": "/rewards/redesign",
  "/balance": "/rewards/redesign",
  "/balance/extract": "/rewards/redesign",
};

export function getLegacyRouteRedirectTarget(pathname: string): string | null {
  return LEGACY_ROUTE_TARGETS[pathname] ?? null;
}

export function resolveLegacyRouteTransition({ isLoading, isNewUi, isRedirectExempt = false }: { isLoading: boolean; isNewUi: boolean; isRedirectExempt?: boolean }): LegacyRouteTransition {
  if (isRedirectExempt) return "render";
  if (isLoading) return "pending";
  return isNewUi ? "redirecting" : "render";
}
